module.exports = __webpack_public_path__ + "img/sad-tear.52f57231.svg";